<template>
	<div class="shenhe">
        <el-card>
            <span>猪场： </span>
            <el-select v-model="address2" placeholder="请选择猪场" style="margin-bottom:20px" clearable >
                <el-option
                    v-for="(item,i) in options"
                    :key="i"
                    :label="item"
                    :value="item">
                </el-option>
            </el-select>

            <span >状态： </span>
            <el-select v-model="zhuangtai2" placeholder="请选择" clearable style="width:100px" >
                <el-option label="待审核" value="0"></el-option>
                <el-option label="通过" value="1"></el-option>
                <el-option label="拒绝" value="2"></el-option>
            </el-select>

            <span>司机： </span>
            <el-input v-model="siji" placeholder="请输入司机姓名" clearable ></el-input>

            <el-button type="success" icon="el-icon-search" @click="getInfo()">查询</el-button>
            <el-button type="info" icon="el-icon-download" @click="exportTable">导出表格</el-button>

            <el-table
                :data="userData"
                stripe
                border
                id="history-table"
                style="width: 100%">

                <el-table-column
                    prop="create_time"
                    label="时间"
                    width='200'>
                </el-table-column>
                
                <el-table-column
                    prop="zhuchang"
                    label="猪场">
                </el-table-column>

                <el-table-column
                    prop="type"
                    label="运载类别">
                </el-table-column>

                <el-table-column
                    prop="danwei"
                    label="运载单位">
                </el-table-column>

                <el-table-column
                    prop="chepai"
                    label="车牌">
                </el-table-column>

                <el-table-column
                    prop="number"
                    label="定额装载量">
                </el-table-column>

                <el-table-column
                    prop="tel"
                    label="登录手机">
                </el-table-column>

                <el-table-column
                    prop="name"
                    label="姓名">
                </el-table-column>

                <el-table-column
                    prop="password"
                    label="登录密码">
                </el-table-column>

                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <p v-if="scope.row.status==0">待审核</p>
                        <p style="color:#67C23A" v-if="scope.row.status==1">审核通过</p>
                        <p style="color:#F56C6C" v-if="scope.row.status==2">审核拒绝</p>
                    </template>
                </el-table-column>

                <el-table-column label="审核" width="140">
                    <template slot-scope="scope">
                        <!-- <div v-if="scope.row.status!=1"> -->
                            <el-button type="text" @click="caoZuo2(scope.row.id,1)">通过</el-button>
                            <el-button type="text" style="color:#F56C6C;font-weight:600" @click="caoZuo2(scope.row.id,2)">拒绝</el-button>
                            <el-button type="text" style="color:#909399" @click="caoZuo2(scope.row.id,3)">删除</el-button>
                        <!-- </div> -->
                    </template>
                </el-table-column>

                <el-table-column
                    prop="shenpiren"
                    label="审核人">
                </el-table-column>

            </el-table>
            
        </el-card>
    </div>
</template>

<script>
    import option from "../config/option.js"
    import { powerList,url2 } from '../router/api';
	export default{
		data(){
			return{
                zhuangtai:'',
                zhuangtai2:'',
                userData: [],
                address2:'',
                name:'',
                options: [],
                siji:'',
            }
        },
        async mounted() {
            await this.getUser()
            await this.getInfo()
        },
      
		methods: {
            exportTable() {
                //导出名称
                let excelName = "历史数据" + new Date().getTime() + ".xlsx";
                const xlsxParam = { raw: true }; //转化成Excel使用原始格式
                const table_book = this.$XLSX.utils.table_to_book(
                    document.querySelector("#history-table"),
                    xlsxParam
                );
                const table_write = this.$XLSX.write(table_book, {
                    bookType: "xlsx",
                    bookSST: true,
                    type: "array",
                });
                try {
                    this.$FileSaver.saveAs(
                    new Blob([table_write], { type: "application/octet-stream" }),
                    excelName
                    );
                } catch (e) {
                    if (typeof console !== "undefined") console.log(e, table_write);
                }
                return table_write;
            },

            caoZuo2(x,y) {
                this.$confirm('是否确定?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.axios.get(url2+'caoZuo2', {
                        params:{
                            id:x,
                            id_status:y,
                            shenpiren:localStorage.getItem('ws_name'),
                        }
                    }).then(res=> {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.getInfo()
                    }).catch(err=> {
                        console.log(err);
                    });
                }).catch(() => {});
               
            },

            async getInfo() {
                await this.axios.get(url2+'searchInfo', {
                    params:{
                        siji:this.siji,
                        zhuchang:this.address2 =='全部' ? '':this.address2,
                        zhuangtai:this.zhuangtai2,
                    }
                }).then(res=> {
                    this.userData = res.data.data
                }).catch(err=> {
                    console.log(err);
                });
            },

            async getUser() {
                await powerList({
                    id:'',
                    name:'',
                    tell: localStorage.getItem('ws_tell'),
                }).then(res => {
                    var list  = res.data[0].org.split(',')
                    list.map(item=> {
                        this.options.push(item)
                    })
                    this.address2 = this.options[0]
                    if(this.address2 == '全部') {
                        this.options = option.zhuchang
                    }
                }).catch(err => {
                    console.log(err);
                });
            },

        }

    }
</script>

<style scoped="scoped" lang='less'>
    .shenhe {
        padding-left: 10px;
        span {
            font-size: 12px;
        }
    }
    .shenhe .el-input {
        width:140px;
        margin-right: 20px;
    }

    .shenhe .el-select {
        width:140px;
        margin-right: 20px;
    }
    .shenhe main {
       margin-bottom: 20px;
    }

</style>